export const CHANNELS = [
  "Airbnb",
  "Booking.com",
  "Comfy Workers",
  "VRBO",
  "Other OTA",
  "Direct Bookings",
  "Not Applicable",
];

export const CHANNEL_COLORS = {
  "Airbnb": "#DC2626",           // red
  "Booking.com": "#1D4ED8",      // blue
  "Comfy Workers": "#0891B2",    // cyan
  "VRBO": "#7C3AED",             // purple
  "Other OTA": "#64748B",        // slate
  "Direct Bookings": "#0F172A",  // slate-900
  "Not Applicable": "#94A3B8",   // slate-400
  "Unassigned": "#CBD5E1",       // slate-300
};

export const CHANNEL_BADGE = {
  "Airbnb": "bg-red-100 text-red-800 border-red-200",
  "Booking.com": "bg-blue-100 text-blue-800 border-blue-200",
  "Comfy Workers": "bg-cyan-100 text-cyan-800 border-cyan-200",
  "VRBO": "bg-violet-100 text-violet-800 border-violet-200",
  "Other OTA": "bg-slate-100 text-slate-700 border-slate-200",
  "Direct Bookings": "bg-slate-900 text-white border-slate-900",
  "Not Applicable": "bg-slate-100 text-slate-500 border-slate-200",
};
